import { useMutation } from "@apollo/client";

import { useCustomerIdGuard } from "../../../../../common/hooks/useCustomerIdGuard";
import {
  GET_ALL_ALERTS,
  GET_USER_ALERTS,
} from "../../../../../common/operations/queries";

import type {
  addAlertEmailNotificationInput,
  AddAlertEmailNotificationMutation,
  AddAlertEmailNotificationMutationVariables,
} from "../../../../../API";
import { ADD_ALERT_EMAIL_NOTIFICATION } from "../../../../../common/operations/mutations";
import { useAuthenticatedUser } from "../../../../../common/hooks/useAuthenticatedUser";
import { CC_ADMIN_ROLES } from "../../../../../common/models/enums";

export const useCreateAlertEmailNotification = () => {
  const selectedCustomerId = useCustomerIdGuard();

  const { role } = useAuthenticatedUser();

  const [saveAlertEmailNotification, { data, loading }] = useMutation<
    AddAlertEmailNotificationMutation,
    AddAlertEmailNotificationMutationVariables
  >(ADD_ALERT_EMAIL_NOTIFICATION);

  const createAlertEmailNotification = async (
    input: addAlertEmailNotificationInput
  ) => {
    let queries = [];

    if (CC_ADMIN_ROLES.includes(role)) {
      queries = [
        {
          query: GET_ALL_ALERTS,
          variables: { customerId: selectedCustomerId },
        },
      ];
    } else {
      queries = [
        {
          query: GET_USER_ALERTS,
          variables: { customerId: selectedCustomerId, email: input.email },
        },
      ];
    }

    return await saveAlertEmailNotification({
      variables: {
        input,
      },
      refetchQueries: queries,
    });
  };

  return { createAlertEmailNotification, data, loading };
};
